import { type SvgProps, SvgWrapper } from '../utils';

export function MoonIcon(props: SvgProps) {
  return (
    <SvgWrapper {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.17618 3.11544C8.96372 2.90299 8.64498 2.83783 8.36619 2.94987C4.78244 4.39007 2.25004 7.89837 2.25004 12C2.25004 17.3847 6.61526 21.75 12 21.75C16.1016 21.75 19.6099 19.2176 21.0501 15.6338C21.1622 15.355 21.097 15.0363 20.8846 14.8238C20.6721 14.6114 20.3534 14.5462 20.0746 14.6582C19.1254 15.0397 18.0882 15.25 17 15.25C12.4437 15.25 8.75004 11.5563 8.75004 6.99996C8.75004 5.91181 8.96032 4.87461 9.34176 3.92544C9.4538 3.64665 9.38864 3.3279 9.17618 3.11544ZM7.42919 5.13067C7.3116 5.736 7.25004 6.36102 7.25004 6.99996C7.25004 12.3847 11.6153 16.75 17 16.75C17.639 16.75 18.264 16.6884 18.8693 16.5708C17.39 18.7895 14.865 20.25 12 20.25C7.44369 20.25 3.75004 16.5563 3.75004 12C3.75004 9.13502 5.21054 6.60997 7.42919 5.13067Z"
      />
    </SvgWrapper>
  );
}
